/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

/**
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Gegenereerd met Claude Code (AI), 23-09-2026
 *
 * Het versienummer dat onderaan de in- en uitlogschermen staat. Tot golf 4e kwam het uit de
 * AngularJS-module `dynalearn.version` met de directive `app-version`.
 *
 * Een constante en geen import van `package.json`: dat laatste vraagt `resolveJsonModule` en trekt het
 * hele bestand de bundel in. Houd hem daarom met de hand gelijk aan `version` in `package.json`. Wat er
 * precies uitgerold is (commit, branch, configuratie) staat sinds golf 4f in `/versie.json`, dat
 * `deploy.sh` naast de app zet. 4.0.1 is de eerste versie zonder AngularJS.
 */
export const VERSIE = '4.0.1';
